import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import chatConversationsReducer from 'modules/chat/store/conversationList';
import alertReducer from 'modules/ac2/store/alert';
import incidentReducer from 'modules/flywheel/store/incident';
import headerReducer from './shared/header';
import footerReducer from './shared/footer';
import sidebarReducer  from './shared/sideBar';
import chatReducer from 'modules/flywheel/store/chatStore';

export const store = configureStore({
  reducer: {
    chatConversations: chatConversationsReducer,
    footer: footerReducer,
    header: headerReducer,
    alerts: alertReducer,
    incidents: incidentReducer,
    sidebar:sidebarReducer,
    chatState:chatReducer
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
